import { Component, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GridComponent {
  /**
   * Отступ между блоками. 16(8 + 8) или 24 (12 + 12)
   *
   * @type {string}
   * @memberof GridComponent
   */
  @Input() gap: string;
  @Input() mobileVerticalGap: string;
}
